var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "450px" } },
    [
      _c(
        "Row",
        { staticStyle: { "margin-top": "50px" }, attrs: { justify: "center" } },
        [
          _c(
            "Col",
            { attrs: { span: "20", offset: "2" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "CheckboxGroup",
                    {
                      attrs: { size: "large" },
                      on: { "on-change": _vm.SetCheckProps },
                      model: {
                        value: _vm.checkAllGroup,
                        callback: function ($$v) {
                          _vm.checkAllGroup = $$v
                        },
                        expression: "checkAllGroup",
                      },
                    },
                    _vm._l(_vm.propList, function (prop, index) {
                      return _c(
                        "Col",
                        { key: index, attrs: { span: "6" } },
                        [
                          _c("Checkbox", {
                            attrs: { label: prop.label, size: "large" },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Row",
        { staticStyle: { "margin-top": "100px" }, attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "6", offset: "18" } },
            [
              _c(
                "Button",
                {
                  staticClass: "btns",
                  attrs: { type: "success", size: "default", shape: "circle" },
                  on: { click: _vm.checkAllChange },
                },
                [_vm._v("全选")]
              ),
              _c(
                "Button",
                {
                  staticClass: "btns",
                  attrs: { type: "primary", size: "default", shape: "circle" },
                  on: { click: _vm.checkNoAllChange },
                },
                [_vm._v("全不选")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }